import * as form from '../form';

export const identificationOthernames = (data = {}) => {
  const names = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Name: form.name(xitem.Name),
        MaidenName: form.radio(xitem.MaidenName), // TODO: Remove after SF no longer used
        DatesUsed: form.daterange(xitem.DatesUsed),
        Reason: form.textarea(xitem.Reason), // TODO: Remove after SF no longer used
        Comments: form.textarea(xitem.Comments), // TODO: Remove after SF no longer used
      },
    };
  });
  return {
    HasOtherNames: form.branch(data.HasOtherNames),
    Comments: form.textarea(data.Comments), // TODO: Remove after SF no longer used
    SummaryComments: form.textarea(data.SummaryComments), // TODO: Remove after SF no longer used
    List: form.collection(names, (data.List || {}).branch),
  };
};
